import getOnline from '../getters/get-online';
import { getReportUrl } from '../config/config';
import { getRequestAdapter, getRestRequestAdapter } from '../config/config-adapters';
import { LOG_PREFIX } from '../config/constants';

/**
 * Тело запроса для отправки метрик
 */

/**
 * Конфиг отправки данных
 */

/**
 * Метод отправки данных
 */

export const sendPackage = async (event, rest = false) => {
  const requestAdapter = rest ? getRestRequestAdapter() : getRequestAdapter();
  if (!getReportUrl()) {
    throw new Error(`${LOG_PREFIX} reportUrl is not defined`);
  }
  if (!getOnline()) {
    throw new Error(`${LOG_PREFIX} Application is offline`);
  }
  if (!requestAdapter) {
    throw new Error(`${LOG_PREFIX} Adapter is not defined`);
  }
  await requestAdapter({
    url: getReportUrl(),
    body: event,
    method: 'POST'
  });
};